import { colors, createCSSVariables } from './colors';

// CSS Variable 사용 헬퍼 함수
export const cssVar = (colorPath) => {
  return `var(--color-${colorPath})`;
};

// 색상 경로로 실제 색상값 가져오기
export const getColor = (category, name) => {
  return colors[category]?.[name] || '#000000';
};

// 투명도 적용 헬퍼 함수
export const withOpacity = (colorPath, opacity) => {
  const color = colorPath.startsWith('var(') ? colorPath : cssVar(colorPath);
  return `${color}${Math.round(opacity * 255).toString(16).padStart(2, '0')}`;
};

// 자주 사용하는 색상들을 쉽게 접근할 수 있는 객체
export const c = {
  // Main colors
  primary: cssVar('main-primary'),
  bg: cssVar('main-bg01'),
  bg02: cssVar('main-bg02'),
  text01: cssVar('main-text01'),
  text02: cssVar('main-text02'),
  textWhite: cssVar('main-text03'),
  
  // Grayscale
  grayHardest: cssVar('grayscale-hardest'),
  grayHard: cssVar('grayscale-hard'),
  grayLight: cssVar('grayscale-light'),
  grayLightest: cssVar('grayscale-lightest'),
  
  // Status colors
  error: cssVar('palette-error'),
  info: cssVar('palette-info'),
  success: cssVar('palette-success'),
  warning: cssVar('palette-warning'),
};

// 하드코딩된 색상값들을 쉽게 교체할 수 있는 매핑
export const legacyColors = {
  '#FDD751': c.primary,
  '#FE536B': c.error,
  '#333333': c.text01,
  '#757575': c.text02,
  '#FFFFFF': c.textWhite,
  '#F0F1F5': c.grayLight,
  '#F7F8FA': c.grayLightest,
  '#BFBFBF': c.grayHard,
  '#8F8F8F': c.grayHardest,
  '#FFFCF0': c.bg02,
  '#868AFF': c.info,
  '#ACDE5F': c.success,
  '#FFB13C': c.warning,
};

// MUI sx prop에서 사용할 색상 유틸리티
export const sx = {
  // 배경색
  bgPrimary: { backgroundColor: 'primary.main' },
  bgError: { backgroundColor: 'error.main' },
  bgSuccess: { backgroundColor: 'success.main' },
  bgWarning: { backgroundColor: 'warning.main' },
  
  // 텍스트 색상
  textPrimary: { color: 'text.primary' },
  textSecondary: { color: 'text.secondary' },
  textError: { color: 'error.main' },
  
  // 테두리
  borderPrimary: { borderColor: 'primary.main' },
  borderError: { borderColor: 'error.main' },
  borderGray: { borderColor: 'grey.400' },
};

// Styled Components에서 사용할 색상 함수
export const theme = {
  colors: c,
  // 테마 기반 색상 선택 (다크모드 대비)
  bg: (props) => props.theme.palette?.background?.default || c.bg,
  text: (props) => props.theme.palette?.text?.primary || c.text01,
  primary: (props) => props.theme.palette?.primary?.main || c.primary,
  
  // 자주 사용하는 패턴들
  errorText: (props) => props.theme.palette?.error?.main || c.error,
  secondaryText: (props) => props.theme.palette?.text?.secondary || c.text02,
  border: (props) => props.theme.palette?.grey?.[400] || c.grayHard,
};

// 색상 교체 헬퍼 함수
export const replaceColor = (hardcodedColor) => {
  return legacyColors[hardcodedColor] || hardcodedColor;
};

// 색상 시스템 초기화 함수 - CSS Variables를 DOM에 동적으로 주입
export const initializeColorSystem = () => {
  const cssVars = createCSSVariables();
  
  // :root에 CSS Variables 적용
  const root = document.documentElement;
  Object.entries(cssVars).forEach(([property, value]) => {
    root.style.setProperty(property, value);
  });
  
  console.log('🎨 Color system initialized with CSS Variables:', cssVars);
};